document.addEventListener('DOMContentLoaded', function() {
  let collectionHandle = sessionStorage.getItem('lastCollectionHandle');
  let collectionTitle = sessionStorage.getItem('lastCollectionTitle');
  if(document.querySelector('.breadcrumbs__collection-link') && collectionTitle && collectionTitle){
    document.querySelector('.breadcrumbs__collection-link').textContent = collectionTitle;
    document.querySelector('.breadcrumbs__collection-link').href = collectionHandle;
  }

  const hybridsBtn = document.getElementById("hybridsBtn");
  const hybridsCancelButton = document.getElementById("hybridsCancelBtn");
  const hybridsDialog = document.getElementById("hybridsDialog");


  hybridsBtn?.addEventListener("click", () => {
    hybridsDialog.showModal();
    hybridsDialog.setAttribute('aria-modal', true);
  });

  if (hybridsCancelButton) {
    hybridsCancelButton.focus();
  }

  hybridsCancelButton?.addEventListener("click", () => {
    hybridsDialog.close();
    hybridsDialog.setAttribute('aria-modal', false);
  });

  hybridsDialog?.addEventListener("click", (event) => {
    if (event.target === hybridsDialog) {
      hybridsDialog.close();
      hybridsDialog.setAttribute('aria-modal', false);
    }
  });

  hybridsCancelButton?.addEventListener('keydown', (e) =>{
    if(e.code == 'Space' || e.key == 'Enter' || e.key == 'Escape'){
      e.preventDefault();
      e.stopPropagation();
      hybridsDialog.close();
      hybridsDialog.setAttribute('aria-modal', false);
    }
  })

  hybridsDialog?.addEventListener('keydown', trapFocus);

  function trapFocus(event) {
    let focusableElements = hybridsDialog.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else { // Tab
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  }

  document.querySelectorAll('.product__selectors .swatch__label').forEach(item => {
    item.addEventListener('keydown', (e) => {
      switch(e.key) {
          case 'Enter':
            e.preventDefault();
            item.closest('.swatch__button').querySelector('.swatch__input').click();
          break;
      }
    });
  })

  document.querySelectorAll('.zin-radio__button').forEach(item => {
    item.querySelector('.zin-radio__label').addEventListener('keydown', (e) => {
      switch(e.key) {
          case 'Enter':
            e.preventDefault();
            item.querySelector('.radio__input').click();
          break;
      }
    });
  })


  const sizeGuideBtn = document.getElementById("sizeGuideBtn");
  const cancelButton = document.getElementById("sizeGuideCancelBtn");
  const sizeModal = document.getElementById("sizeGuideDialog");

  sizeGuideBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    sizeModal.setAttribute('aria-modal', true);
    sizeModal.showModal();
    
  });

  // if (cancelButton) {
  //   cancelButton.focus();
  // }

  cancelButton?.addEventListener("click", () => {
    sizeModal.close();
    sizeModal.setAttribute('aria-modal', false);
  });

  cancelButton?.addEventListener('keydown', (e) =>{
    if(e.code == 'Space' || e.key == 'Enter' || e.key == 'Escape'){
      e.preventDefault();
      e.stopPropagation();
      sizeModal.setAttribute('aria-modal', false);
      sizeModal.close();
    }
  })

  sizeModal?.addEventListener("click", (event) => {
    if (event.target === sizeModal) {
      sizeModal.setAttribute('aria-modal', false);
      sizeModal.close();
    }
  });

  dialog?.addEventListener("click", (event) => {
    if (event.target === dialog) {
        dialog.close();
    }
  })

  sizeModal?.addEventListener('keydown', sizetrapFocus);

  function sizetrapFocus(event) {
    let focusableElements = sizeModal.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];
    if (event.key === 'Tab') {
      if (event.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement) {
          event.preventDefault();
          lastFocusableElement.focus();
        }
      } else { // Tab
        if (document.activeElement === lastFocusableElement) {
          event.preventDefault();
          firstFocusableElement.focus();
        }
      }
    }
  }
  // PRODUCT PAGE PRICING - MATERIAL RADIO BUTTONS
  const memoryFoam = document.querySelector('.zin-memory-foam');
  const hybrid = document.querySelector('.zin-hybrid');

  const memoryFoamMobile = document.querySelector('.zin-memory-foam-mobile');
  const hybridMobile = document.querySelector('.zin-hybrid-mobile');

  const materialMemoryFoam1 = document.querySelector('.zin-material-memory-foam-1');
  const materialMemoryFoam2 = document.querySelector('.zin-material-memory-foam-2');

  const materialHybrid1 = document.querySelector('.zin-material-hybrid-1');
  const materialHybrid2 = document.querySelector('.zin-material-hybrid-2');

  const memoryFoamRadioButton = document.querySelector('.zin-material-radio-1 .zin-material-label');
  const hybridRadioButton = document.querySelector('.zin-material-radio-2 .zin-material-label');

  memoryFoamRadioButton?.addEventListener('click', () => {
    memoryFoam.classList.remove('hidden');
    memoryFoamMobile.classList.remove('hidden');

    hybrid.classList.add('hidden');
    hybridMobile.classList.add('hidden');

    materialMemoryFoam1.classList.remove('hidden');
    materialHybrid1.classList.add('hidden');
    materialMemoryFoam2.classList.remove('hidden');
    materialHybrid2.classList.add('hidden');

  });

  hybridRadioButton?.addEventListener('click', () => {
    memoryFoam.classList.add('hidden');
    memoryFoamMobile.classList.add('hidden');

    hybrid.classList.remove('hidden');
    hybridMobile.classList.remove('hidden');

    materialMemoryFoam1.classList.add('hidden');
    materialHybrid1.classList.remove('hidden');
    materialMemoryFoam2.classList.add('hidden');
    materialHybrid2.classList.remove('hidden');
  });
  setTimeout(function() {
    var currentURL = window.location.href;
    let checkZinus = document.querySelector('.zinus-original');
    if(checkZinus && currentURL.includes('40316113')){
      document.querySelector('.ultra-cooling-green-tea').classList.add('hidden');
      document.querySelector('#zinusOriginalRadio').classList.remove('opacity');
      document.querySelector('.cooling-green-tea').classList.remove('opacity');
    }else if(checkZinus && currentURL.includes('4032118')){
      document.querySelector('#zinusOriginalRadio').classList.add('hidden');
      document.querySelector('.ultra-cooling-green-tea').classList.remove('opacity');
      document.querySelector('.cooling-green-tea').classList.remove('opacity');
      document.querySelector('.cooling-green-tea .most_popular').classList.add('hidden');
      document.querySelector('.cooling-green-tea .compare_at_price').classList.add('hidden');
    }else if(checkZinus && currentURL.includes('4040070')){
      document.querySelector('.pdp-variant-1-text').classList.add('hidden');
      document.querySelectorAll('.zin-radio__button').forEach(item=>{
        item.classList.add('hidden');
      })
      document.querySelectorAll('.zin-radio__button').forEach(item=>{
        item.classList.remove('opacity');
      })
    }
  }, 1000);
  function convertDiscountDivToH2() {
    const productBlocks = document.querySelectorAll('.product__block');
    let found = false;
    
    if (productBlocks.length > 0) {
      productBlocks.forEach(block => {
        const allDivs = block.querySelectorAll('div');        
        allDivs.forEach(div => {
          if (!div.parentNode || div.tagName === 'H2' || div.hasAttribute('data-converted-to-h2')) return;
          
          const styleAttr = div.getAttribute('style') || '';
          if (styleAttr.includes('color') && 
              (styleAttr.includes('#FFFFFF') || styleAttr.includes('#ffffff')) &&
              styleAttr.includes('font-size') &&
              styleAttr.includes('15px') &&
              styleAttr.includes('font-weight') &&
              styleAttr.includes('500')) {
            
            const h2 = document.createElement('h2');
            div.setAttribute('data-converted-to-h2', 'true');
            
            Array.from(div.attributes).forEach(attr => {
              h2.setAttribute(attr.name, attr.value);
            });
            
            h2.innerHTML = div.innerHTML;
            div.parentNode.replaceChild(h2, div);
            found = true;
          }
        });
      });
    }
    if (!found) {
      const allDivs = document.querySelectorAll('div');      
      allDivs.forEach(div => {
        if (!div.parentNode || div.tagName === 'H2' || div.hasAttribute('data-converted-to-h2')) return;
        
        const styleAttr = div.getAttribute('style') || '';
        // Convert div to h2 if it has the discount message styling pattern
        if (styleAttr.includes('color') && 
            (styleAttr.includes('#FFFFFF') || styleAttr.includes('#ffffff')) &&
            styleAttr.includes('font-size') &&
            styleAttr.includes('15px') &&
            styleAttr.includes('font-weight') &&
            styleAttr.includes('500')) {
          const h2 = document.createElement('h2');
          div.setAttribute('data-converted-to-h2', 'true');            
          Array.from(div.attributes).forEach(attr => {
            h2.setAttribute(attr.name, attr.value);
          });            
          h2.innerHTML = div.innerHTML;
          div.parentNode.replaceChild(h2, div);
        }
      });
    }
  }
  convertDiscountDivToH2();
  setTimeout(convertDiscountDivToH2, 500);
  setTimeout(convertDiscountDivToH2, 1000);
  setTimeout(convertDiscountDivToH2, 2000);
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        shouldCheck = true;
      }
    });
    if (shouldCheck) {
      convertDiscountDivToH2();
    }
  });
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})
